import { LinkedIn, Instagram, Facebook, Mail } from '@mui/icons-material'
import { Box, IconButton } from '@mui/material'

function SocialLink() {
    function goTo(link: string) {
        window.open(link)
    }

    return (

        <Box gap={1} display={"flex"}>
            <IconButton style={{backgroundColor: "rgba(255, 255, 255, .8)", padding: "5px"}} onClick={() => { /* goTo("https://www.linkedin.com/company/86344109") */ }} color='info'><LinkedIn /></IconButton>
            {/* <IconButton style={{backgroundColor: "rgba(255, 255, 255, .8)", padding: "5px"}} onClick={() => { goTo("") }} color='inherit'><GitHub /></IconButton> */}
            <IconButton style={{backgroundColor: "rgba(255, 255, 255, .8)", padding: "5px"}} onClick={() => { goTo("https://www.instagram.com/nkh_2023/") }} color='error'><Instagram /></IconButton>
            <IconButton style={{backgroundColor: "rgba(255, 255, 255, .8)", padding: "5px"}} onClick={() => { goTo("https://www.facebook.com/profile.php?id=61579415502548") }} color='info'><Facebook /></IconButton>
            <IconButton style={{backgroundColor: "rgba(255, 255, 255, .8)", padding: "5px"}} onClick={() => { window.location.href = "mailto:contact@nkhconstruction.com" }} color='error'><Mail /></IconButton>
        </Box>
    )
}

export default SocialLink
